export function initGradientLoader(): void {
    document.querySelectorAll<HTMLElement>( '.gradient-loader' ).forEach( ( element: HTMLElement ) => element.classList.remove( 'gradient-loader' ) );
}
